import {Component, DestroyRef, OnInit, computed, inject, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {Router} from '@angular/router';
import {DashboardStatisticsService} from '../../../dashboard-analytics/services/dashboard-statistics.service';

@Component({
  selector: 'app-missing-tunings-card',
  templateUrl: './missing-tunings-card.component.html',
  styleUrls: ['./missing-tunings-card.component.css']
})
export class MissingTuningsCardComponent implements OnInit {

  private readonly statsService = inject(DashboardStatisticsService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);

  readonly partialTotal = signal<number>(0);
  readonly missingTotal = signal<number>(0);
  readonly isLoading = signal<boolean>(true);

  readonly grandTotal = computed(() => this.partialTotal() + this.missingTotal());

  readonly partialPct = computed(() =>
    this.grandTotal() ? Math.round((this.partialTotal() / this.grandTotal()) * 100) : 0
  );

  readonly missingPct = computed(() =>
    this.grandTotal() ? Math.round((this.missingTotal() / this.grandTotal()) * 100) : 0
  );

  ngOnInit(): void {
    this.load();
  }

  private load(): void {
    this.isLoading.set(true);
    this.statsService.getMissingAndPartialTotals()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (totals) => {
          this.partialTotal.set(totals?.numberOfPartialMissingTunings ?? 0);
          this.missingTotal.set(totals?.numberOfMissingTunings ?? 0);
          this.isLoading.set(false);
        },
        error: () => this.isLoading.set(false)
      });
  }

  openMissingPartial(type: 'missing' | 'partial'): void {
    this.router.navigate(['/app/requested-tunings/requested-tunings-tables'], {
      queryParams: {type}
    });
  }

  openMissingTable(): void {
    this.openMissingPartial('missing');
  }

  openPartialTable(): void {
    this.openMissingPartial('partial');
  }
}
